import type { JSONContent } from '@tiptap/core';

/**
 * Flattens a tiptap document into a single line of plain text for snippets.
 * Inline siblings are joined as-is (marks don't split words); block nodes and
 * hard breaks become single spaces so the result reads as one line. A mention
 * reads as the member name, like it shows on screen.
 */
export const extractTiptapText = (content: JSONContent | null | undefined): string => {
  if (!content || typeof content !== 'object') {
    return '';
  }

  const walk = (node: JSONContent): string => {
    if (node.type === 'text') {
      return node.text ?? '';
    }

    if (node.type === 'hardBreak') {
      return ' ';
    }

    if (node.type === 'mention') {
      return typeof node.attrs?.label === 'string' ? node.attrs.label : '';
    }

    if (!Array.isArray(node.content)) {
      return '';
    }

    return `${node.content.map(walk).join('')} `;
  };

  return walk(content).replace(/\s+/g, ' ').trim();
};
